import Api from '@/utils/Api'


export default class ReportApi extends Api {

    static getClass () {
        if (!this.instance) {
            this.instance = new ReportApi();
        }
        return this.instance;
    }

    // 按“故障类型”统计
    type = (param) => {
        return this.$mhttp.httpGet(this.$constant.API_NSC + 'order/faultTypeStatics', param, null);
    }

}